import { MESSAGE_TYPES } from './constants';
import { getExternalEchoSource } from './messageOrigin';

export const shouldGroupMessages = (current, next) => {
  if (!current || !next || next.status === 'failed') return false;

  const nextSenderId = next.senderId ?? next.sender?.id;
  const currentSenderId = current.senderId ?? current.sender?.id;
  if (nextSenderId !== currentSenderId) return false;

  const nextMessageType = next.messageType;
  const currentMessageType = current.messageType;
  const areBothTemplates =
    nextMessageType === MESSAGE_TYPES.TEMPLATE &&
    currentMessageType === MESSAGE_TYPES.TEMPLATE;
  if (areBothTemplates || currentMessageType !== nextMessageType) return false;

  const currentOrigin = getExternalEchoSource(current.contentAttributes);
  const nextOrigin = getExternalEchoSource(next.contentAttributes);
  if (currentOrigin !== nextOrigin) return false;

  return Math.floor(next.createdAt / 60) === Math.floor(current.createdAt / 60);
};
